import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Link from '@/links';

import styles from './breadcrumbs.module.scss';

const propTypes = {
  clickableLink: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired
};

const Breadcrumbs = ({clickableLink, title, activeTab}) => (
    <div className={cx(styles.breadcrumbs, 'no-print')}>
      <ul>
        <li>
          <Link variant="green800" href={clickableLink.urlCopy}>
            {clickableLink.text}
          </Link>
        </li>
        <li>
          <p>{title}</p>
        </li>
        <li>
          <p>{activeTab}</p>
        </li>
      </ul>
    </div>
  );

Breadcrumbs.propTypes = propTypes;

export default Breadcrumbs;
